import Swiper from 'swiper/bundle';

let quoteOptions = {
    loop: true,
    spaceBetween: 24,
    speed: 1000,
    slidesPerView: "auto",
    navigation: {
        nextEl: ".news .swiper-button-next",
        prevEl: ".news .swiper-button-prev",
    },
    breakpoints: {
        300: {
            spaceBetween: 32,
        },
        1025: {
            spaceBetween: 24,
        }
    }

};
(function ($) {
    let quote = new Swiper(".news__slider", quoteOptions);

})(jQuery);